import { Button } from "@ui/components/button";
import {
	Empty,
	EmptyContent,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle,
} from "@ui/components/empty";
import { CircleAlertIcon, SearchXIcon } from "lucide-react";
import type { ReactNode } from "react";

/**
 * The empty states the split-pane screens share (inbox, calls, orders): a list
 * that filters hide everything from, a detail that failed to load, and the
 * pane that waits for a pick.
 */

export function NoMatches({
	title,
	clearLabel,
	onClear,
}: {
	title: string;
	clearLabel: string;
	onClear: () => void;
}) {
	return (
		<Empty className="m-auto">
			<EmptyHeader>
				<EmptyMedia variant="icon">
					<SearchXIcon />
				</EmptyMedia>
				<EmptyTitle>{title}</EmptyTitle>
			</EmptyHeader>
			<EmptyContent>
				<Button variant="outline" size="sm" onClick={onClear}>
					{clearLabel}
				</Button>
			</EmptyContent>
		</Empty>
	);
}

export function DetailUnavailable({
	title,
	backLabel,
	onBack,
	onRetry,
}: {
	title: string;
	backLabel: string;
	onBack: () => void;
	onRetry: () => void;
}) {
	return (
		<Empty className="m-auto">
			<EmptyHeader>
				<EmptyMedia variant="icon">
					<CircleAlertIcon />
				</EmptyMedia>
				<EmptyTitle>{title}</EmptyTitle>
			</EmptyHeader>
			<div className="flex gap-2">
				<Button variant="outline" size="sm" onClick={onBack}>
					{backLabel}
				</Button>
				<Button size="sm" onClick={onRetry}>
					Try again
				</Button>
			</div>
		</Empty>
	);
}

export function PaneEmpty({
	icon,
	title,
	description,
}: {
	icon: ReactNode;
	title: string;
	description: ReactNode;
}) {
	return (
		<Empty className="m-auto">
			<EmptyHeader>
				<EmptyMedia variant="icon">{icon}</EmptyMedia>
				<EmptyTitle>{title}</EmptyTitle>
				<EmptyDescription>{description}</EmptyDescription>
			</EmptyHeader>
		</Empty>
	);
}
